<div class="send-email-sample" [formGroup]="form">
  <div class="send-email-sample_content">
    <app-input-field
      [type]="InputFieldType.Text"
      [form]="form"
      controlName="email"
      label="Email"
    ></app-input-field>
    <button class="btn-ghost" (click)="onSendEmailClick()">Send Test Email</button>
  </div>
  <p class="hint">Please, note that inside sample email variables will NOT be replaced with the values</p>
</div>
